import React, { useState, useEffect, useRef } from 'react';
import Hosts from '../../Hosts'
import {reqGET, reqPOST, passwordHash} from '../../Utils'

import { confirmAlert } from 'react-confirm-alert';
//import { getTokenInfo } from '../../UseToken';

const RecuperarForm = (props) => {

  const [, set_dados] = useState(null);
  const username = useRef(null);
  const confirmed = useRef(null);
  
  //const [/*companycode,*/ setCompanyCode] = useState('');
  const [password, setPassword] = useState('');
  const [password_conf, setPasswordConf] = useState('');

  const [input_type, setInputType] = useState('password');

  const handleSubmit = e => {

    e.preventDefault();
    localStorage.clear();

    let el = {
      companycode: Hosts.companycode, 
      recovery_hash: props.hash, 
      new_password: passwordHash(password)
    }

    console.log('el', el)


    if(password !== '' && password === password_conf) {
      reqPOST(Hosts.SIMCore_API + '/' + props.loginType, el)
      .then(res => {
        if (parseInt(res.status) === 200) {
          console.log('SETOU->', res.status)

          if(props.type === 'access') {
            confirmAlert({
              title: 'Recuperação da accesso',
              message: 'A sua palavra-chave foi definida com sucesso.',
              buttons: [
                {
                  label: 'Seguir para o Login',
                  onClick: () => { go_to_login() }
                }
              ]
            })
          }
          else {
            confirmAlert({
              title: 'Recuperação da palavra-chave',
              message: 'A sua palavra-chave foi alterada com sucesso.',
              buttons: [
                {
                  label: 'Voltar',
                  onClick: () => { return }
                }
              ]
            });
          }

          set_dados(confirmed.current = true)

          setTimeout(() => {
            window.location.href = Hosts.EMAIL_WEB_SITE_URL_TEXT;
      		}, 5000);

          localStorage.clear();
        }
        else {
          confirmAlert({
            title: 'Erro de Recuperação',
            message: 'Dados de acesso incorretos',
            buttons: [
              {
                label: 'Seguir para o Login',
                onClick: () => { go_to_login() }
              }

            ]
          });

          setTimeout(() => {
            window.location.href = Hosts.EMAIL_WEB_SITE_URL_TEXT;
      		}, 5000);

          localStorage.clear();
          //setToken(token);
        }
      })
    }
    else {
      confirmAlert({
          message: 'Palavra-chave de confirmação diferente.',
          buttons: [
            {
              label: 'Voltar',
              onClick: () => { return }
            }

          ]
        })
    }
  }

  const togglePwd = async e => {
    if (input_type.localeCompare('text') === 0)
      setInputType('password');
    else
      setInputType('text');
  }

  const go_to_login = () => {
    window.location.href = Hosts.EMAIL_WEB_SITE_URL_TEXT;
  }

  useEffect(() => {

    (async () => {

      if(props.type === 'access') {

        set_dados(confirmed.current = false)

        let res = await reqGET(Hosts.SIMCore_API + '/entities/hash/' + Hosts.companycode + '/' + props.hash)
        console.log('res', res)
        if(Array.isArray(res.data) && res.data.length > 0) {
          set_dados(username.current = res.data[0].info.username)
        }
      }
        
    })()

  }, [])

  return (
    <form onSubmit={handleSubmit} style={(props.type === 'access' ? { maxWidth: '550px' } : '')}>
      {
      username.current !== undefined && username.current !== null && username.current !== '' ?
      <div>
        <h4>Recuperar de Acessa à área de Federado.</h4>
        <p>Guarde o seu nome de utilizador e defina a sua palavra-chave.</p>
        <br />
        <br />
      </div>
      :
        null
      }
      {
      username.current !== undefined && username.current !== null && username.current !== '' ?
        <div className="form-group mb-4 position-relative">
          <label>
            <p>Utilizador</p>
            <input className="form-input input-pwd" value={username.current} disabled={true} />
          </label>
        </div>
      :
        null
      }
      <div className="form-group mb-4 position-relative">
        <label>
          <p>Palavra-chave</p>
          <input type={input_type} className="form-input input-pwd" value={password} onChange={(e) => setPassword(e.target.value)} />
          <img alt='' onClick={togglePwd} src={ input_type === 'password' ? './img/view.svg' : './img/view_password.svg'} />
        </label>
      </div>
      <div className="form-group 5 position-relative">
        <label>
          <p>Confirmação Palavra-chave</p>
          <input type={input_type} className="form-input input-pwd" value={password_conf} onChange={(e) => setPasswordConf(e.target.value)} />
          <img alt='' onClick={togglePwd} src={ input_type === 'password' ? './img/view.svg' : './img/view_password.svg'} />
        </label>
      </div>
      
      <div className="form-group">
        <button className="form-button btn-primary" type="submit">Recuperar</button>
      </div>
    </form>
  );


}

export default RecuperarForm;
